var AccessLevel;
(function (AccessLevel) {
    AccessLevel["Public"] = "public";
    AccessLevel["Private"] = "private";
    AccessLevel["Protected"] = "protected";
})(AccessLevel || (AccessLevel = {}));
export { AccessLevel as A };
